export function castEnum(value) {
    return value;
}
export function castOptionalEnum(value) {
    return value;
}
export function sureOf(entity) {
    if (entity == null) {
        throw new Error("sureOf(): value not present");
    }
    return entity;
}
export function sortUsingMap(items, indexes, keyFn) {
    return items.sort((a, b) => { var _a, _b; return ((_a = indexes.get(keyFn(a))) !== null && _a !== void 0 ? _a : -1) - ((_b = indexes.get(keyFn(b))) !== null && _b !== void 0 ? _b : -1); });
}
